import { notFound, redirect } from "@tanstack/react-router";
import type { ContentResult } from "@/lib/content-types";
import { buildLocalizedPath } from "@/lib/i18n/locale";
export function requirePublicContent<T>(
	result: ContentResult<T>,
	path: string,
	search?: string,
	hash?: string,
) {
	if (result.status === "not-found") throw notFound();
	if (result.status === "translation-missing")
		throw redirect({
			href: buildLocalizedPath(path, search, hash, result.locale),
			statusCode: 307,
		});
	return result;
}
